import React from "react";
import PropTypes from "prop-types";
import CertificationType from './CertificationType'

class CertificationGroup extends React.Component {
  state = {
    expandedView: false
  }

  render() {
    const {
      user,
      certificationGroup,
      usersCertifications,
      usersCertificationStepResults,
      programDirectors,
      instructorTrainers,
      trainingCenters,
      handlerAddStep,
      formUrl,
      handleCertificationUpdate,
      isSaiAdmin,
      viewOnly
    } = this.props;

    return (
      <div className='u-form-width-fix full-width'>
        <button
          className="btn btn-block btn-default certification-header"
          onClick={this.toggleExpandedView}
          onKeyDown={this.handleKeyDown}
          tabIndex="0"
        >
          <span className="pull-right">
            {this.state.expandedView ? (
              <i className="material-icons icon-for-nav" aria-hidden="true">remove</i>
            ) : (
              <i className="material-icons icon-for-nav" aria-hidden="true">add</i>
            )}
          </span>
          <h2 className="text-center">{certificationGroup.name}</h2>
        </button>
        <div className="panel-group">
          {(this.state.expandedView || this.displayGroup()) && certificationGroup.certification_types.map((certificationType, index) =>
            <CertificationType
              key={`ct-${certificationType.id}`}
              user={user}
              certificationType={certificationType}
              usersCertificationStepResults={usersCertificationStepResults}
              programDirectors={programDirectors}
              instructorTrainers={instructorTrainers}
              trainingCenters={trainingCenters}
              certification={this.findUsersCertificationByType(certificationType)}
              handlerAddStep={handlerAddStep}
              formUrl={formUrl}
              handleCertificationUpdate={handleCertificationUpdate}
              isSaiAdmin={isSaiAdmin}
              expandedView={this.state.expandedView}
              viewOnly={viewOnly}
            />
          )}
        </div>
      </div>
    )
  }

  findUsersCertificationByType = (certificationType) => {
    return this.props.usersCertifications.find(usersCertification => usersCertification.certification_type_id === certificationType.id)
  };

  displayGroup = () => {
    let certificationTypeIds = this.props.certificationGroup.certification_types.map(certification_type => (certification_type.id));
    return this.props.usersCertifications.filter(usersCertification => certificationTypeIds.includes(usersCertification.certification_type_id)).length > 0;
  };

  toggleExpandedView = () => {
    this.setState(prevState => ({
      expandedView: !prevState.expandedView
    }));
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.toggleExpandedView();
    }
  };
};

CertificationGroup.propType = {
  user: PropTypes.object,
  certificationGroup: PropTypes.object,
  usersCertifications: PropTypes.array,
  usersCertificationStepResults: PropTypes.array,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  handlerAddStep: PropTypes.func,
  formUrl: PropTypes.string,
  handleCertificationUpdate: PropTypes.func,
  isSaiAdmin: PropTypes.bool,
  viewOnly: PropTypes.bool
};

export default CertificationGroup;
